import { render, staticRenderFns } from "./TNotification.vue?vue&type=template&id=2e1c7cca&scoped=true&"
import script from "./TNotification.vue?vue&type=script&lang=js&"
export * from "./TNotification.vue?vue&type=script&lang=js&"
import style0 from "./TNotification.vue?vue&type=style&index=0&id=2e1c7cca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1c7cca",
  null
  
)

export default component.exports